interface FacebookPixelEventData {
  eventID?: string;
}

interface BaseEventParameters {
  value?: number;
  currency?: string;
  content_name?: string;
  content_type?: string;
  content_ids?: string[];
  external_id?: string;
  [key: string]: any;
}

declare global {
  interface Window {
    fbq: {
      (
        command: 'track',
        eventName: string,
        parameters?: BaseEventParameters,
        eventData?: FacebookPixelEventData,
      ): void;
      (command: 'trackCustom', eventName: string, parameters?: BaseEventParameters): void;
      (
        command: 'trackSingle',
        pixelId: string,
        eventName: string,
        parameters?: BaseEventParameters,
        eventData?: FacebookPixelEventData,
      ): void;
      (
        command: 'trackSingleCustom',
        pixelId: string,
        eventName: string,
        parameters?: BaseEventParameters,
      ): void;
      (command: string, ...args: any[]): void;
    };
  }
}

export const FacebookPixel = {
  pageView: () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }
  },

  track: (event: string, parameters?: BaseEventParameters, eventData?: FacebookPixelEventData) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, parameters, eventData);
    }
  },

  trackCustom: (event: string, parameters?: BaseEventParameters) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', event, parameters);
    }
  },

  trackSingle: (
    pixelId: string,
    event: string,
    parameters?: BaseEventParameters,
    eventData?: FacebookPixelEventData,
  ) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackSingle', pixelId, event, parameters, eventData);
    }
  },

  trackSingleCustom: (pixelId: string, event: string, parameters?: BaseEventParameters) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackSingleCustom', pixelId, event, parameters);
    }
  },
};
